import cn from 'classnames';
import React from 'react';

import { ButtonObject } from 'shared/types/notebookTypes';

export const ToolbarButton = ({ innerText, className, style, value, disabled }: ButtonObject) => {
  return innerText ? (
    <button
      className={cn(className, disabled && 'disabled')}
      style={style}
      disabled={disabled}
      value={value}
      type="button"
    >
      {innerText}
    </button>
  ) : (
    <button
      className={cn(className, disabled && 'disabled')}
      style={style}
      disabled={disabled}
      value={value}
      type="button"
    />
  );
};
